/*
  Plus Saat — Favoriler (2026-09-27, kart/favori revizyonu; tema-claude-design: ProductCard, Product, Header, Favorites)
  Girişsiz, cihaz başına liste. localStorage 'ps:favoriler' = [{"id":123,"handle":"seiko-..."}], en yeni başta, en çok 48.
  (Tasarım yalnız handle tutuyordu; id, favoriler sayfasının tek istekte "id:" aramasıyla dolması için — handle silinen
  ürün temizliği için saklanır.) Tasarım önizlemesindeki "boşsa 6 örnek favori ekle" davranışı BİLEREK YOK.
  Öğeler: <ps-favori> kalp (kart + ürün sayfası), <ps-favori-sayac> header rozeti, <ps-favoriler> /pages/favoriler.
  Her öğe durumunu connectedCallback'te okur: filtre AJAX'ı, ilgili ürünler, son bakılanlar gibi sonradan gelen kartlar
  kendiliğinden eşitlenir. Ekleyince header'ın altında 3 sn bildirim (görsel + ad + FAVORİLERİM). Bu dosyada Liquid YOK.
*/
(() => {
  if (window.psFavori) return;

  const ANAHTAR = 'ps:favoriler';
  const AZAMI = 48; // sections/ps-favori-sonuc.liquid "paginate by 48" ile aynı
  const OLAY = 'ps:favori:degisti';
  const TOAST_SURE = 3000;
  const KOK = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const FAVORI_URL = `${KOK}pages/favoriler`;
  const KALP = 'M12 20.3s-7.6-4.5-9.3-9.3C1.5 7.5 3.8 4 7.3 4c2 0 3.7 1.1 4.7 2.8C13 5.1 14.7 4 16.7 4c3.5 0 5.8 3.5 4.6 7-1.7 4.8-9.3 9.3-9.3 9.3Z';
  const METIN = {
    eklendi: 'Favorilere eklendi',
    ekle: 'Favorilere ekle',
    ekli: 'Favorilerde',
    kayitYok: 'Favoriler bu tarayıcıda kaydedilemiyor',
    cikarildi: 'Favorilerden çıkarıldı',
    sinir: `En fazla ${AZAMI} favori saklanır; en eski favorin listeden çıkarıldı.`,
    link: 'Favorilerim',
    buton: 'FAVORİLERİM',
    saat: 'saat'
  };

  const oku = () => {
    try {
      const v = JSON.parse(localStorage.getItem(ANAHTAR) || '[]');
      if (!Array.isArray(v)) return [];
      // Bozuk/elle düzenlenmiş değer: aynı id iki kez (rozet şişer, kart iki kez basılır) ya da 48'den uzun liste
      const gorulen = new Set();
      return v
        .filter((x) => x && Number.isInteger(x.id) && !gorulen.has(x.id) && gorulen.add(x.id))
        .slice(0, AZAMI);
    } catch (e) {
      return []; // Safari gizli pencere vb.
    }
  };

  const yaz = (liste) => {
    try {
      localStorage.setItem(ANAHTAR, JSON.stringify(liste.slice(0, AZAMI)));
      return true;
    } catch (e) {
      return false;
    }
  };

  const ekliMi = (id) => oku().some((x) => x.id === id);
  const yay = (detay = {}) => document.dispatchEvent(new CustomEvent(OLAY, { detail: detay }));
  const el = (etiket, sinif, metin) => {
    const d = document.createElement(etiket);
    if (sinif) d.className = sinif;
    if (metin) d.textContent = metin;
    return d;
  };
  const svgKalp = (genislik, dolu) => {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', String(genislik));
    svg.setAttribute('viewBox', '0 0 24 24');
    const p = document.createElementNS(ns, 'path');
    p.setAttribute('d', KALP);
    p.setAttribute('fill', dolu ? 'currentColor' : 'none');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.5');
    p.setAttribute('stroke-linejoin', 'round');
    svg.append(p);
    return svg;
  };

  // ---------------------------------------------------------------- bildirim (Header.dc.html favToast)
  // Görsel kutu (.ps-toast) ekran okuyucudan gizli DEĞİL ama canlı bölge değil; duyuru ayrı, her zaman erişilebilir
  // sr-only canlı bölgeden yapılır (görünmez hâldeki içerik değişimi duyurulmaz).
  let toastEl = null;
  let duyuruEl = null;
  let toastZaman = 0;
  const toastHazirla = () => {
    if (toastEl || !document.body) return;
    toastEl = el('div', 'ps-toast');
    toastEl.addEventListener('mouseenter', () => clearTimeout(toastZaman));
    toastEl.addEventListener('focusin', () => clearTimeout(toastZaman));
    toastEl.addEventListener('mouseleave', () => toastKapatZamanla());
    toastEl.addEventListener('focusout', (e) => {
      if (!toastEl.contains(e.relatedTarget)) toastKapatZamanla();
    });
    duyuruEl = el('div', 'sr-only');
    duyuruEl.setAttribute('role', 'status');
    duyuruEl.setAttribute('aria-live', 'polite');
    document.body.append(toastEl, duyuruEl);
  };
  // Aynı metni yeniden yazmak ekran okuyucuda tekrar duyurulmaz: önce boşalt, sonraki turda yaz
  const duyur = (mesaj) => {
    toastHazirla();
    if (!duyuruEl) return;
    duyuruEl.textContent = '';
    setTimeout(() => {
      duyuruEl.textContent = mesaj;
    }, 50);
  };
  const toastKapatZamanla = () => {
    clearTimeout(toastZaman);
    toastZaman = setTimeout(() => toastEl && toastEl.classList.remove('is-visible'), TOAST_SURE);
  };
  const toastKonumla = () => {
    // Header'ın alt kenarının 12px (mobil 8px) altı; header yapışkan olduğu için kaydırmada da görünür kalır
    const header = document.querySelector('.shopify-section--header');
    const alt = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const bosluk = window.matchMedia('(min-width: 700px)').matches ? 12 : 8;
    toastEl.style.setProperty('--ps-toast-ust', `${Math.round(alt + bosluk)}px`);
  };
  const toast = (bilgi) => {
    toastHazirla();
    if (!toastEl) return;
    const icerik = [];
    if (bilgi.basit) {
      toastEl.classList.add('ps-toast--basit');
      icerik.push(el('span', 'ps-toast__baslik', bilgi.basit));
      duyur(bilgi.basit);
    } else {
      toastEl.classList.remove('ps-toast--basit');
      if (bilgi.gorsel) {
        const kutu = el('span', 'ps-toast__gorsel');
        const img = el('img');
        img.src = bilgi.gorsel;
        img.alt = '';
        img.width = 52;
        img.height = 52;
        kutu.append(img);
        icerik.push(kutu);
      }
      const metin = el('span', 'ps-toast__metin');
      const baslik = el('span', 'ps-toast__baslik');
      baslik.append(svgKalp(15, true), METIN.eklendi);
      metin.append(baslik);
      if (bilgi.marka || bilgi.ad) {
        const ad = el('span', 'ps-toast__ad');
        if (bilgi.marka) {
          const m = el('span', '', bilgi.marka);
          m.lang = 'en';
          ad.append(m, ' ');
        }
        ad.append(bilgi.ad || '');
        metin.append(ad);
      }
      if (bilgi.not) metin.append(el('span', 'ps-toast__not', bilgi.not));
      const link = el('a', 'ps-toast__link', METIN.buton);
      link.href = FAVORI_URL;
      icerik.push(metin, link);
      duyur([`${METIN.eklendi}: ${[bilgi.marka, bilgi.ad].filter(Boolean).join(' ')}`, bilgi.not].filter(Boolean).join('. '));
    }
    toastEl.replaceChildren(...icerik);
    toastKonumla();
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth; // yeniden ekleme: kayma animasyonu baştan
    toastEl.classList.add('is-visible');
    toastKapatZamanla();
  };

  const degistir = (id, handle, bilgi = {}) => {
    const liste = oku();
    const ekliydi = liste.some((x) => x.id === id);
    const yeni = ekliydi ? liste.filter((x) => x.id !== id) : [{ id, handle }, ...liste];
    if (!ekliydi && liste.length >= AZAMI) bilgi = { ...bilgi, not: METIN.sinir }; // yaz() en eskiyi keser
    if (!yaz(yeni)) {
      toast({ basit: METIN.kayitYok });
      return;
    }
    yay({ id, handle, eklendi: !ekliydi });
    if (!ekliydi) toast(bilgi); // tasarım: bildirim yalnız eklemede
    // İsteğe bağlı ölçüm (Web Pixel özel olayı) — ölçüm kararı verilince aç:
    // window.Shopify?.analytics?.publish?.('ps_favori', { id, handle, eklendi: !ekliydi });
  };

  // ---------------------------------------------------------------- <ps-favori> kalp
  class PsFavori extends HTMLElement {
    connectedCallback() {
      this.urunId = parseInt(this.getAttribute('product-id'), 10);
      this.dugme = this.querySelector('button');
      if (!this.dugme || !this.urunId) return;
      // Masaüstü raylar (<scroll-carousel allow-drag>) fareyle sürüklenir; kalpte başlayıp biten sürükleme tıklama
      // sayılmasın. stopPropagation YOK: carousel'in kendi "sürüklemeden sonraki tıklamayı iptal" dinleyicisi
      // (once) tüketilmeli, yoksa kurulu kalır ve aynı raydaki sonraki klavye Enter'ını (clientX 0) iptal eder.
      this.basla = null;
      this.bas = (e) => {
        this.basla = [e.clientX, e.clientY];
      };
      this.tikla = (e) => {
        e.preventDefault();
        const b = this.basla;
        this.basla = null;
        // detail 0 = klavye (Enter/Boşluk): her zaman geçerli
        if (e.detail > 0 && b && Math.abs(e.clientX - b[0]) + Math.abs(e.clientY - b[1]) > 6) return;
        degistir(this.urunId, this.getAttribute('handle') || '', {
          marka: this.dataset.marka || '',
          ad: this.dataset.ad || '',
          gorsel: this.dataset.gorsel || ''
        });
      };
      this.esitleBagli = () => this.esitle();
      this.dugme.addEventListener('pointerdown', this.bas);
      this.dugme.addEventListener('click', this.tikla);
      document.addEventListener(OLAY, this.esitleBagli);
      this.esitle();
    }

    disconnectedCallback() {
      if (this.dugme) {
        this.dugme.removeEventListener('pointerdown', this.bas);
        this.dugme.removeEventListener('click', this.tikla);
      }
      document.removeEventListener(OLAY, this.esitleBagli);
    }

    esitle() {
      // Erişilebilir ad sabit ("Favori: Seiko Presage SRPL75J", Liquid basar); durum yalnız aria-pressed'de.
      // title yalnız fare ipucu.
      const ekli = ekliMi(this.urunId);
      this.dugme.setAttribute('aria-pressed', String(ekli));
      this.dugme.setAttribute('title', ekli ? METIN.ekli : METIN.ekle);
      this.classList.toggle('is-ekli', ekli);
    }
  }

  // ---------------------------------------------------------------- <ps-favori-sayac> header rozeti (0 ise boş/gizli)
  class PsFavoriSayac extends HTMLElement {
    connectedCallback() {
      this.esitleBagli = () => this.esitle();
      document.addEventListener(OLAY, this.esitleBagli);
      this.esitle();
    }

    disconnectedCallback() {
      document.removeEventListener(OLAY, this.esitleBagli);
    }

    esitle() {
      const adet = oku().length;
      this.textContent = adet ? String(adet) : '';
      const sr = this.parentElement && this.parentElement.querySelector('.sr-only');
      if (sr) sr.textContent = adet ? `${METIN.link} (${adet})` : METIN.link;
    }
  }

  // ---------------------------------------------------------------- <ps-favoriler> /pages/favoriler
  class PsFavoriler extends HTMLElement {
    connectedCallback() {
      this.govde = this.querySelector('[data-ps-govde]') || this;
      this.liste = this.querySelector('[data-ps-liste]');
      this.bos = this.querySelector('[data-ps-bos]');
      this.hata = this.querySelector('[data-ps-hata]');
      this.adetEl = this.querySelector('[data-ps-adet]');
      this.tur = 0;
      this.degistiBagli = (e) => this.degisti(e.detail || {});
      document.addEventListener(OLAY, this.degistiBagli);
      this.yukle();
    }

    disconnectedCallback() {
      document.removeEventListener(OLAY, this.degistiBagli);
    }

    adet(n) {
      if (this.adetEl) this.adetEl.textContent = `${n} ${METIN.saat}`;
    }

    durum(ad) {
      // 'yukleniyor' | 'dolu' | 'bos' | 'hata'
      this.setAttribute('durum', ad);
      this.govde.setAttribute('aria-busy', String(ad === 'yukleniyor'));
      this.liste.hidden = ad !== 'dolu';
      this.bos.hidden = ad !== 'bos';
      this.hata.hidden = ad !== 'hata';
      if (ad === 'bos') this.adet(0);
    }

    async yukle() {
      const tur = ++this.tur;
      const favoriler = oku();
      if (!favoriler.length) {
        this.liste.replaceChildren();
        this.durum('bos');
        return;
      }
      this.adet(favoriler.length);
      this.durum('yukleniyor');
      const q = favoriler.map((x) => `id:${x.id}`).join(' OR ');
      const url = `${KOK}search?type=product&options[unavailable_products]=last&options[prefix]=none&q=${encodeURIComponent(q)}&section_id=ps-favori-sonuc`;
      try {
        const yanit = await fetch(url);
        if (!yanit.ok) throw new Error(`HTTP ${yanit.status}`);
        const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');
        if (tur !== this.tur) return; // arada yeni yükleme başladı
        const sonuc = belge.querySelector('[data-ps-sonuc]');
        if (!sonuc) throw new Error('ps-favori-sonuc çıktı vermedi');
        const isaret = belge.querySelector('[data-ps-bulunan]');
        const bulunan = ((isaret && isaret.getAttribute('data-ps-bulunan')) || '')
          .split(',')
          .filter(Boolean)
          .map(Number);
        const eksik = favoriler.filter((x) => !bulunan.includes(x.id));
        if (!bulunan.length) {
          // Hiçbiri gelmedi: gerçekten silinmişler mi (404) yoksa arama mı çalışmadı ("id:" sorgusu, gizli ürün)?
          // Temizlikten sonra hâlâ favori varsa sahte "Henüz favori saatin yok" yerine hata göster.
          await this.temizle(eksik);
          if (tur !== this.tur) return;
          this.liste.replaceChildren();
          this.durum(oku().length ? 'hata' : 'bos');
          return;
        }
        this.liste.replaceChildren(document.importNode(sonuc, true));
        this.adet(bulunan.length);
        this.durum('dolu');
        if (eksik.length) this.temizle(eksik);
      } catch (e) {
        console.warn('[ps-favori]', e);
        if (tur === this.tur) this.durum('hata');
      }
    }

    // Aramada çıkmayan favori yalnız ürün gerçekten yoksa (404) silinir; tükenen/gizlenen ürün listede kalır
    async temizle(eksik) {
      const silinecek = [];
      await Promise.all(
        eksik.map(async (x) => {
          if (!x.handle) return;
          try {
            const r = await fetch(`${KOK}products/${encodeURIComponent(x.handle)}.js`);
            if (r.status === 404) silinecek.push(x.id);
          } catch (e) {
            /* ağ hatası: dokunma */
          }
        })
      );
      if (!silinecek.length) return;
      yaz(oku().filter((x) => !silinecek.includes(x.id)));
      yay({ temizlendi: silinecek });
    }

    degisti(detay) {
      if (detay.temizlendi) return; // zaten gösterilmeyen ürünler; sayaç kendi eşitlenir
      if (detay.eklendi === false && detay.id) {
        // Tasarım: bu sayfada kalbe basınca kart listeden anında çıkar. Odak kaybolmasın: sonraki (yoksa önceki)
        // kartın kalbine, liste boşaldıysa boş durum düğmesine taşınır; kalan adet canlı bölgeden duyurulur.
        const kartlar = [...this.liste.querySelectorAll('product-card')];
        const gidenler = [...this.liste.querySelectorAll(`ps-favori[product-id="${detay.id}"]`)]
          .map((k) => k.closest('product-card'))
          .filter(Boolean);
        if (!gidenler.length) return;
        const odakVardi = gidenler.some((k) => k.contains(document.activeElement));
        const i = kartlar.indexOf(gidenler[0]);
        const komsu =
          kartlar.slice(i + 1).find((k) => !gidenler.includes(k)) ||
          kartlar.slice(0, i).reverse().find((k) => !gidenler.includes(k));
        gidenler.forEach((k) => k.remove());
        const kalan = this.liste.querySelectorAll('product-card').length;
        if (!kalan) this.durum('bos');
        this.adet(kalan);
        if (odakVardi) {
          const hedef = komsu
            ? komsu.querySelector('.ps-favori__dugme')
            : this.bos.querySelector('a') || this.querySelector('h1');
          if (hedef) {
            if (!hedef.matches('a, button')) hedef.tabIndex = -1;
            hedef.focus();
          }
        }
        duyur(`${METIN.cikarildi}. ${kalan} ${METIN.saat}`);
        return;
      }
      if (detay.eklendi === true) return; // bu sayfadan ekleme olmaz (tüm kartlar zaten favori)
      this.yukle(); // başka sekmeden değişiklik / geri-ileri önbelleği dönüşü
    }
  }

  // Başka sekme değiştirdi ya da sayfa bfcache'ten döndü → herkes yeniden okusun
  window.addEventListener('storage', (e) => {
    if (e.key === ANAHTAR || e.key === null) yay({ disaridan: true });
  });
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) yay({ disaridan: true });
  });

  const tanimla = (ad, sinif) => {
    if (!customElements.get(ad)) customElements.define(ad, sinif);
  };
  tanimla('ps-favori', PsFavori);
  tanimla('ps-favori-sayac', PsFavoriSayac);
  tanimla('ps-favoriler', PsFavoriler);
  if (document.body) toastHazirla();
  else document.addEventListener('DOMContentLoaded', toastHazirla);

  window.psFavori = { oku, degistir }; // hata ayıklama / GTM için
})();
